/**
 * @generated SignedSource<<8ca3f62843cfb4a07a89e2e9daab182c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type PaymentProvider = "DLOCAL_GO" | "STRIPE" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type GuildDonationScreenContent_guild$data = {
  readonly donationCurrency: string | null | undefined;
  readonly id: string;
  readonly minimumDonationAmount: number | null | undefined;
  readonly paymentProvider: PaymentProvider | null | undefined;
  readonly slugId: string;
  readonly stripeAccountId: string | null | undefined;
  readonly " $fragmentType": "GuildDonationScreenContent_guild";
};
export type GuildDonationScreenContent_guild$key = {
  readonly " $data"?: GuildDonationScreenContent_guild$data;
  readonly " $fragmentSpreads": FragmentRefs<"GuildDonationScreenContent_guild">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "GuildDonationScreenContent_guild",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slugId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "minimumDonationAmount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "donationCurrency",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "stripeAccountId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "paymentProvider",
      "storageKey": null
    }
  ],
  "type": "Guild",
  "abstractKey": null
};

(node as any).hash = "2efe52919c404b509db16e389ff089d2";

export default node;
